import { useNavigate } from "react-router-dom";
import {
  Box,
  Button,
  Grid2 as Grid,
  useTheme,
  useMediaQuery,
} from "@mui/material";
import { useState } from "react";
import { LoadingButton } from "@mui/lab";

const HomeComponent = () => {
  const navigate = useNavigate();
  const theme = useTheme();
  const isMd = useMediaQuery(theme.breakpoints.down("lg"));
  const isXs = useMediaQuery(theme.breakpoints.down("sm"));
  const [navigateLoading, setNavigateLoading] = useState(false);

  return (
    <Grid
      container
      sx={
        isXs
          ? {
              backgroundImage: "url('/img/website_img/homeImg.jpeg')",
              backgroundSize: "cover",
              height: "60vh",
            }
          : isMd
            ? {
                backgroundImage: "url('/img/website_img/homeImg.jpeg')",
                backgroundSize: "cover",
                height: "52vh",
              }
            : {
                backgroundImage: "url('/img/website_img/homeImg.jpeg')",
                height: "100vh",
              }
      }
    >
      <Grid size={{ sm: 12, xs: 12 }}>
        <Box
          display="flex"
          // justifyContent="left"
          sx={{ flexDirection: "column", position: "relative" }}
        >
          <img
            style={
              isXs
                ? {
                    width: "8rem",
                    marginLeft: "auto",
                    marginRight: "auto",
                    marginTop: "0.5rem",
                    // marginBottom: "4.2rem",
                  }
                : {
                    width: "10rem",
                    marginLeft: "auto",
                    marginRight: "auto",
                    marginTop: "1rem",
                  }
            }
            alt="Permit Rockstar Logo"
            src="/img/logos/PR_Logo_black.png"
          />

          {/* Store Badges - Only on mobile, under logo, above buttons */}
          {/* {isXs && (
            <Box
              sx={{
                display: "flex",
                justifyContent: "flex-start",
                width: "100%",
                px: 2,
              }}
            >
              <img
                style={{
                  width: "150px",
                  height: "auto",
                  maxWidth: "100%",
                }}
                alt="Download on App Store and Google Play"
                src="/img/website_img/store_badges.png"
              />
            </Box>
          )} */}

          <Box
            sx={{
              mt: isXs ? 0 : 1,
              alignItems: "center",
              display: "flex",
              flexDirection: "column",
              gap: isXs ? 1 : 1,
              width: "100%",
            }}
          >
            <Button
              onClick={(e) => {
                navigate("/login");
              }}
              fullWidth
              sx={{ maxWidth: isXs ? "85%" : "50%" }}
              color="primary"
              size={isXs ? "medium" : "large"}
              variant="contained"
            >
              L O G I N
            </Button>
            <LoadingButton
              loading={navigateLoading}
              onClick={(e) => {
                setNavigateLoading(true);
                window.location.href = "https://permitrockstar.com/pricing/";
              }}
              color="primary"
              size={isXs ? "medium" : "large"}
              fullWidth
              sx={{ maxWidth: isXs ? "85%" : "50%" }}
              variant="contained"
            >
              C R E A T E &nbsp; A N &nbsp; A C C O U N T
            </LoadingButton>
          </Box>

          {/* Store Badges
          {!isXs && (
            <Box
              sx={{
                mt: 3,
                display: "flex",
                justifyContent: "flex-start",
                width: "100%",
                px: isXs ? 2 : 0,
              }}
            >
              <img
                style={{
                  width: isXs ? "150px" : "180px",
                  height: "auto",
                  maxWidth: "100%",
                }}
                alt="Download on App Store and Google Play"
                src="/img/website_img/store_badges.png"
              />
            </Box>
          )} */}
        </Box>
      </Grid>
    </Grid>
  );
};

export default HomeComponent;
